window.WemondProductRecipes = {
  "signature-espresso-blend": {
    "profile": "Kakao ve karamelize şeker • Şurupsu gövde • Sütle uyumlu",
    "equipment": "Espresso, Moka Pot, AeroPress",
    "methods": [
      "espresso",
      "mokapot",
      "aeropress"
    ],
    "recipes": [
      {
        "key": "espresso",
        "label": "Espresso",
        "ratio": "18 g kahve / 38 g çıktı (1:2,1)",
        "grind": "Espresso inceliği. MHW-3 Bomber: espresso ayarı / Comandante C40: 8–10 klik",
        "temperature": "93°C",
        "duration": "27–30 saniye",
        "steps_html": "<li>Portafiltreyi kuru tut; 18 g kahveyi eşit dağıt ve düz tamp yap.</li><li><strong>0:00</strong> shotı başlat; ilk damlalar 6–9 saniyede gelmeli.</li><li><strong>27–30 sn / 38 g</strong> çıktıda durdur.</li><li>Sütlü içimde aynı shot; sade içimde 40 g’a uzatmak daha yumuşak bir fincan verir.</li>",
        "note": "Hedef: kakao ve karamelize şeker merkezli, şurupsu gövdeli shot; sütte kaybolmayan tatlılık.",
        "adjust": [
          [
            "Ekşi / kısa",
            "Bir kademe incelt."
          ],
          [
            "Acı / kuru",
            "Bir kademe kalınlaştır veya 40 g’a uzat."
          ],
          [
            "Sütte kayboluyor",
            "Oranı 1:2’ye sıkılaştır."
          ]
        ]
      },
      {
        "key": "mokapot",
        "label": "Moka Pot",
        "ratio": "16 g kahve / 160 g su (3 cup)",
        "grind": "Orta-ince, espressodan belirgin kalın. MHW-3 Bomber: 18–20 klik / Comandante C40: 15–17 klik",
        "temperature": "Hazneye ~85°C sıcak su",
        "duration": "3:00–4:00",
        "steps_html": "<li>Alt hazneye sıcak suyu valfin hemen altına kadar koy.</li><li>Sepeti doldur, üstünü düzle; tamp yapma.</li><li>Orta-düşük ateşte kapağı açık demle.</li><li>Akış açık kahverengiye dönüp fokurdamaya başlamadan ocaktan al; tabanı ıslak bezle soğut.</li>",
        "note": "Evde yoğun, kakao tatlılığı yüksek bir fincan; sütle de iyi çalışır.",
        "adjust": [
          [
            "Acı / yanık",
            "Ateşi kıs ve daha erken kapat."
          ],
          [
            "Sulu",
            "Bir kademe incelt."
          ]
        ]
      },
      {
        "key": "aeropress",
        "label": "AeroPress · süt bazı",
        "ratio": "18 g kahve / 110 g su (1:6)",
        "grind": "İnce-orta. MHW-3 Bomber: 16–18 klik / Comandante C40: 13–15 klik",
        "temperature": "92°C",
        "duration": "1:30–1:45",
        "steps_html": "<li>Ters (inverted) konum.</li><li><strong>0:00 / 110 g</strong> su ekle, 10 kez hızlı karıştır.</li><li><strong>0:45</strong> kapağı tak, çevir.</li><li><strong>1:00–1:30</strong> sabit ve güçlü bastır.</li><li>Konsantreyi 120–150 g sütle tamamla.</li>",
        "note": "Espresso makinesi olmayanlar için yoğun bir süt bazı: kakao ve karamel sütle öne çıkar.",
        "adjust": [
          [
            "Ekşi",
            "Beklemeyi 1:00’e uzat."
          ],
          [
            "Fazla yoğun",
            "Suyu 130 g’a çıkar."
          ]
        ]
      }
    ]
  },
  "brazil-cerrado": {
    "profile": "Sütlü çikolata • Badem • Karamel • Düşük asidite",
    "equipment": "Espresso, Moka Pot, French Press",
    "methods": [
      "espresso",
      "mokapot",
      "frenchpress"
    ],
    "recipes": [
      {
        "key": "espresso",
        "label": "Espresso",
        "ratio": "18 g kahve / 40 g çıktı (1:2,2)",
        "grind": "Espresso inceliği. MHW-3 Bomber: espresso ayarı / Comandante C40: 9–11 klik",
        "temperature": "92°C",
        "duration": "27–31 saniye",
        "steps_html": "<li>18 g kahveyi dağıt, düz tamp yap.</li><li><strong>27–31 sn / 40 g</strong> çıktıda durdur.</li>",
        "note": "Hedef: sütlü çikolata ve badem tatlılığı; düşük asiditeli, yumuşak bir shot.",
        "adjust": [
          [
            "Ağır / acı",
            "42 g’a uzat veya 91°C’ye in."
          ],
          [
            "Düz",
            "Bir kademe incelt."
          ]
        ]
      },
      {
        "key": "mokapot",
        "label": "Moka Pot",
        "ratio": "16 g kahve / 160 g su (3 cup)",
        "grind": "Orta-ince. MHW-3 Bomber: 19–21 klik / Comandante C40: 16–18 klik",
        "temperature": "Hazneye ~85°C sıcak su",
        "duration": "3:00–4:00",
        "steps_html": "<li>Alt hazneye sıcak suyu valfin altına kadar koy.</li><li>Sepeti doldur, düzle; tamp yok.</li><li>Orta-düşük ateş, kapak açık.</li><li>Fokurdama başlamadan ocaktan al.</li>",
        "note": "Karamel ve çikolata ağırlıklı, yoğun ama yumuşak bir moka.",
        "adjust": [
          [
            "Acı",
            "Daha erken kapat."
          ],
          [
            "Sulu",
            "Bir kademe incelt."
          ]
        ]
      },
      {
        "key": "frenchpress",
        "label": "French Press",
        "ratio": "20 g kahve / 320 g su (1:16)",
        "grind": "Kalın. MHW-3 Bomber: 34–36 klik / Comandante C40: 32–34 klik",
        "temperature": "93°C",
        "duration": "4:00 + 3:00 çökelme",
        "steps_html": "<li><strong>0:00 / 320 g</strong> suyun hepsini dök.</li><li><strong>4:00</strong> yüzeydeki kabuğu kır, köpüğü kaşıkla al.</li><li><strong>4:00–7:00</strong> çökelmeye bırak.</li><li>Pistonu sadece yüzeye indir, yavaşça dök.</li>",
        "note": "Tam gövdeli, badem ve çikolata tatlılığı yüksek bir fincan.",
        "adjust": [
          [
            "Çamurlu",
            "Çökelmeyi uzat, pistonu bastırma."
          ],
          [
            "Zayıf",
            "22 g’a çıkar."
          ]
        ]
      }
    ]
  },
  "brazil-rio-minas": {
    "profile": "Yoğun • Düşük asidite • Tok gövde",
    "equipment": "Espresso, French Press, Aeropress, Cold Brew",
    "methods": [
      "espresso",
      "frenchpress",
      "aeropress",
      "coldbrew"
    ],
    "recipes": [
      {
        "key": "espresso",
        "label": "Espresso",
        "ratio": "18 g kahve / 36–38 g çıktı",
        "grind": "Espresso inceliği. MHW-3 Bomber: espresso ayarı / Comandante C40: 8–10 klik.",
        "temperature": "91–92°C",
        "duration": "25–29 saniye",
        "steps_html": "<li><strong>0:00–0:07</strong> kısa pre-infusion.</li><li><strong>0:07–0:22</strong> kontrollü ama çok yavaş olmayan akış.</li><li><strong>0:25–0:29 / 36–38 g çıktı</strong> aralığında bitir.</li><li>Fazla yoğun gelirse çıktıyı 40 g’a yaklaştır.</li>",
        "note": "Rio Minas’ta amaç tok gövde ve klasik kahve karakteri; fazla uzatma sertlik verebilir."
      },
      {
        "key": "frenchpress",
        "label": "French Press",
        "ratio": "18 g kahve / 300 g su",
        "grind": "MHW-3 Bomber: 34–36 klik / Comandante C40: 32–35 klik",
        "temperature": "91–92°C",
        "duration": "4:00 + 5:00 çökelme",
        "steps_html": "<li><strong>0:00–0:20 / 300 g</strong> suyu ekle ve tüm kahveyi ıslat.</li><li><strong>0:20–4:00</strong> hiç karıştırmadan bekle.</li><li><strong>4:00</strong> yüzeyi kır ve köpüğü al.</li><li><strong>4:00–9:00</strong> pistonu bastırmadan çökelmeye bırak.</li><li><strong>9:00</strong> pistonu sadece yüzeye indirip yavaş servis et.</li>",
        "note": "Tok gövdeyi öne çıkarır; acele servis bulanıklığı ve sertliği artırır."
      },
      {
        "key": "aeropress",
        "label": "Aeropress",
        "ratio": "17 g kahve / 200 g su",
        "grind": "MHW-3 Bomber: 21–22 klik / Comandante C40: 18–19 klik",
        "temperature": "90–91°C",
        "duration": "1:30–1:40",
        "steps_html": "<li><strong>0:00–0:15 / 70 g</strong> su ekle ve 5 kez karıştır.</li><li><strong>0:15–0:40 / 200 g</strong> suyu tamamla.</li><li><strong>0:40–1:15</strong> bekle.</li><li><strong>1:15–1:40</strong> bastır.</li>",
        "note": "Daha kısa ve yoğun reçete; Rio Minas’ın sertleşmesini engeller."
      },
      {
        "key": "coldbrew",
        "label": "Cold Brew",
        "ratio": "45 g kahve / 450 g su",
        "grind": "MHW-3 Bomber: 36–38 klik / Comandante C40: 35–38 klik",
        "temperature": "Soğuk / oda sıcaklığı",
        "duration": "14–16 saat",
        "steps_html": "<li><strong>0:00</strong> kahve ve suyu kavanozda birleştir.</li><li><strong>0:00–1:00</strong> tüm kahvenin ıslandığından emin ol.</li><li><strong>14–16 saat</strong> oda sıcaklığına yakın beklet.</li><li>Süre sonunda kağıt filtreyle süz ve soğuk servis et.</li>",
        "note": "Çikolata, kavruk tatlılık ve tok gövde için en uygun Rio Minas reçetesi."
      }
    ]
  },
  "honduras-250g": {
    "profile": "Yumuşak • Orta asidite • Günlük içim",
    "equipment": "V60, Espresso, French Press, Filtre Kahve Makinesi",
    "methods": [
      "v60",
      "espresso",
      "frenchpress",
      "filtre-makinesi"
    ],
    "recipes": [
      {
        "key": "v60",
        "label": "V60",
        "ratio": "15 g kahve / 245 g su",
        "grind": "MHW-3 Bomber: 25 klik / Comandante C40: 22–23 klik",
        "temperature": "92°C",
        "duration": "2:40–3:00",
        "steps_html": "<li><strong>0:00–0:30 / 30 g</strong> blooming.</li><li><strong>0:30–1:05 / 120 g</strong> sakin ve merkez ağırlıklı dök.</li><li><strong>1:05–1:40 / 190 g</strong> geniş daireyle devam et.</li><li><strong>1:40–2:05 / 245 g</strong> tamamla.</li>",
        "note": "Günlük içim için tatlı ve sakin fincan; oranı biraz kısa tutarak gövdeyi koruyoruz."
      },
      {
        "key": "espresso",
        "label": "Espresso",
        "ratio": "18 g kahve / 40–42 g çıktı",
        "grind": "Espresso inceliği. MHW-3 Bomber: espresso ayarı / Comandante C40: 8–10 klik.",
        "temperature": "92°C",
        "duration": "27–31 saniye",
        "steps_html": "<li><strong>0:00–0:08</strong> kısa pre-infusion.</li><li><strong>0:08–0:24</strong> akış çok incelmeden ilerlemeli.</li><li><strong>0:27–0:31 / 40–42 g çıktı</strong> aralığında bitir.</li>",
        "note": "Honduras yoğun değil; yumuşak espresso profili isteyenler için dengeli çalışır."
      },
      {
        "key": "frenchpress",
        "label": "French Press",
        "ratio": "17 g kahve / 280 g su",
        "grind": "MHW-3 Bomber: 33–35 klik / Comandante C40: 31–34 klik",
        "temperature": "92°C",
        "duration": "4:00 + 4:00 çökelme",
        "steps_html": "<li><strong>0:00–0:20 / 280 g</strong> su ekle.</li><li><strong>0:20–4:00</strong> bekle.</li><li><strong>4:00</strong> yüzeyi kır ve köpüğü al.</li><li><strong>4:00–8:00</strong> çökelmeye bırak.</li><li><strong>8:00</strong> yavaş servis et.</li>",
        "note": "Yumuşak, tatlı ve sakin günlük fincan verir."
      },
      {
        "key": "filtre-makinesi",
        "label": "Filtre Kahve Makinesi",
        "ratio": "30 g kahve / 500 g su",
        "grind": "MHW-3 Bomber: 27–29 klik / Comandante C40: 25–28 klik",
        "temperature": "92°C",
        "duration": "Makine döngüsü",
        "steps_html": "<li>Filtreyi durula.</li><li>30 g kahveyi yatağa eşit yay.</li><li>500 g suyla demlemeyi başlat.</li><li>Demleme sonrası karafı hafifçe çalkala.</li>",
        "note": "Makinede dengeli, sade ve düşük riskli günlük kahve."
      }
    ]
  },
  "honduras-shb": {
    "profile": "Dengeli • Orta asidite • Orta gövde",
    "equipment": "V60, Chemex, Espresso, French Press",
    "methods": [
      "v60",
      "chemex",
      "espresso",
      "frenchpress"
    ],
    "recipes": [
      {
        "key": "v60",
        "label": "V60",
        "ratio": "15 g kahve / 250 g su",
        "grind": "MHW-3 Bomber: 24–25 klik / Comandante C40: 21–23 klik",
        "temperature": "93°C",
        "duration": "2:55–3:15",
        "steps_html": "<li><strong>0:00–0:40 / 35 g</strong> blooming; SHB yapı için biraz uzun bekle.</li><li><strong>0:40–1:15 / 125 g</strong> merkeze kontrollü dök.</li><li><strong>1:15–1:55 / 200 g</strong> orta hızda devam et.</li><li><strong>1:55–2:25 / 250 g</strong> tamamla ve kısa swirl yap.</li>",
        "note": "SHB yapısı daha sıkı olduğu için sıcaklık ve blooming biraz yükseltildi."
      },
      {
        "key": "chemex",
        "label": "Chemex",
        "ratio": "24 g kahve / 390 g su",
        "grind": "MHW-3 Bomber: 28–29 klik / Comandante C40: 26–28 klik",
        "temperature": "93°C",
        "duration": "4:10–4:35",
        "steps_html": "<li><strong>0:00–0:40 / 50 g</strong> blooming.</li><li><strong>0:40–1:30 / 175 g</strong> yavaş ve geniş daire dök.</li><li><strong>1:30–2:25 / 300 g</strong> devam et.</li><li><strong>2:25–3:15 / 390 g</strong> tamamla.</li>",
        "note": "Chemex, Honduras SHB’nin dengeli yapısını daha berrak gösterir."
      },
      {
        "key": "espresso",
        "label": "Espresso",
        "ratio": "18 g kahve / 40 g çıktı",
        "grind": "Espresso inceliği. MHW-3 Bomber: espresso ayarı / Comandante C40: 8–10 klik.",
        "temperature": "92–93°C",
        "duration": "27–30 saniye",
        "steps_html": "<li><strong>0:00–0:08</strong> kısa pre-infusion.</li><li><strong>0:08–0:24</strong> stabil akış hedefle.</li><li><strong>0:27–0:30 / 40 g çıktı</strong> aralığında bitir.</li>",
        "note": "Yoğun değil; dengeli espresso karakteri için uygundur."
      },
      {
        "key": "frenchpress",
        "label": "French Press",
        "ratio": "18 g kahve / 300 g su",
        "grind": "MHW-3 Bomber: 34–35 klik / Comandante C40: 32–34 klik",
        "temperature": "93°C",
        "duration": "4:00 + 5:00 çökelme",
        "steps_html": "<li><strong>0:00–0:20 / 300 g</strong> su ekle.</li><li><strong>0:20–4:00</strong> bekle.</li><li><strong>4:00</strong> yüzeyi kırıp köpüğü al.</li><li><strong>4:00–9:00</strong> çökelmeye bırak.</li><li><strong>9:00</strong> yavaş servis et.</li>",
        "note": "Gövdeyi güçlendirir, asiditeyi yumuşatır."
      }
    ]
  },
  "signature-filter-brew": {
    "profile": "Çiçeksi • Kırmızı meyve • Bal ve tatlı baharat",
    "equipment": "V60, Filtre Kahve Makinesi, Chemex, AeroPress",
    "methods": [
      "v60",
      "filtre-makinesi",
      "chemex",
      "aeropress"
    ],
    "recipes": [
      {
        "key": "v60",
        "label": "V60",
        "ratio": "15 g kahve / 250 g su (1:16,7)",
        "grind": "Orta-ince. MHW-3 Bomber: 24–25 klik / Comandante C40: 21–23 klik",
        "temperature": "93°C",
        "duration": "2:45–3:05",
        "steps_html": "<li><strong>0:00 / 40 g</strong> bloom, 35 saniye.</li><li><strong>0:35 / 150 g</strong> ana döküş.</li><li><strong>1:15 / 250 g</strong> tamamla, hafif swirl.</li><li><strong>2:45–3:05</strong> bitiş.</li>",
        "note": "Günlük, tekrarlanabilir bir filtre: çiçeksi açılış, bal ve tatlı baharat bitiş.",
        "adjust": [
          [
            "Ekşi",
            "Bir kademe incelt."
          ],
          [
            "Kuru",
            "Bir kademe kalınlaştır."
          ]
        ]
      },
      {
        "key": "filtre-makinesi",
        "label": "Filtre Kahve Makinesi",
        "ratio": "60 g kahve / 1.000 g su (1:16,7)",
        "grind": "Orta. MHW-3 Bomber: 28–30 klik / Comandante C40: 26–28 klik",
        "temperature": "92–94°C (makine)",
        "duration": "Makine döngüsü (5–6 dk)",
        "steps_html": "<li>Kağıt filtreyi durula.</li><li>60 g kahveyi düz bir yatağa yay.</li><li>Blooming modu varsa kullan.</li><li>Bittiğinde karafı çalkalayıp servis et.</li>",
        "note": "Büyük demlemede bile dengeli: kırmızı meyve ve bal tatlılığı.",
        "adjust": [
          [
            "Zayıf",
            "65 g’a çıkar."
          ],
          [
            "Acı",
            "Bir kademe kalınlaştır."
          ]
        ]
      },
      {
        "key": "chemex",
        "label": "Chemex",
        "ratio": "30 g kahve / 500 g su (1:16,7)",
        "grind": "Orta. MHW-3 Bomber: 28–29 klik / Comandante C40: 26–27 klik",
        "temperature": "94°C",
        "duration": "4:00–4:30",
        "steps_html": "<li><strong>0:00 / 70 g</strong> bloom, 45 saniye.</li><li><strong>0:45 / 280 g</strong> döküş.</li><li><strong>1:45 / 500 g</strong> tamamla.</li><li><strong>4:00–4:30</strong> bitiş.</li>",
        "note": "Paylaşmak için temiz ve çiçeksi bir sürahi.",
        "adjust": [
          [
            "Uzun süzülüyor",
            "Bir kademe kalınlaştır."
          ]
        ]
      },
      {
        "key": "aeropress",
        "label": "AeroPress",
        "ratio": "15 g kahve / 230 g su (1:15,3)",
        "grind": "Orta-ince. MHW-3 Bomber: 22–23 klik / Comandante C40: 19–21 klik",
        "temperature": "93°C",
        "duration": "2:00–2:15",
        "steps_html": "<li><strong>0:00 / 230 g</strong> suyun hepsini dök, 3 kez karıştır, pistonu tak.</li><li><strong>1:30</strong> swirl.</li><li><strong>1:45–2:15</strong> yavaş bastır.</li>",
        "note": "Tek fincan için daha yuvarlak ve gövdeli.",
        "adjust": [
          [
            "Ekşi",
            "Beklemeyi 20 sn uzat."
          ]
        ]
      }
    ]
  },
  "guatemala-antigua": {
    "profile": "Karamel • Kakao • Tatlı baharat",
    "equipment": "Espresso, V60, AeroPress, Filtre Kahve Makinesi",
    "methods": [
      "espresso",
      "v60",
      "aeropress",
      "filtre-makinesi"
    ],
    "recipes": [
      {
        "key": "espresso",
        "label": "Espresso",
        "ratio": "18 g kahve / 38–40 g çıktı",
        "grind": "Espresso inceliği. MHW-3 Bomber: espresso ayarı / Comandante C40: 8–10 klik.",
        "temperature": "92°C",
        "duration": "27–30 saniye",
        "steps_html": "<li><strong>0:00–0:08</strong> kısa pre-infusion.</li><li><strong>0:08–0:23</strong> akış dengeli ve orta hızda ilerlemeli.</li><li><strong>0:27–0:30 / 38–40 g çıktı</strong> aralığında bitir.</li><li>Fazla baharatlı veya sert gelirse çıktıyı 41–42 g’a yaklaştır.</li>",
        "note": "Karamel, kakao ve tatlı baharat hissi veren yumuşak espresso profili."
      },
      {
        "key": "v60",
        "label": "V60",
        "ratio": "16 g kahve / 255 g su",
        "grind": "MHW-3 Bomber: 24–25 klik / Comandante C40: 21–23 klik",
        "temperature": "92–93°C",
        "duration": "2:55–3:15",
        "steps_html": "<li><strong>0:00–0:35 / 35 g</strong> blooming.</li><li><strong>0:35–1:10 / 140 g</strong> tatlılığı açmak için orta hızda dök.</li><li><strong>1:10–1:50 / 215 g</strong> geniş daireyle devam et.</li><li><strong>1:50–2:20 / 255 g</strong> tamamla.</li>",
        "note": "Antigua’da amaç tatlı gövdeyi korumak; bu yüzden oran biraz daha yoğun ve döküş daha kontrollü."
      },
      {
        "key": "chemex",
        "label": "Chemex",
        "ratio": "25 g kahve / 400 g su",
        "grind": "MHW-3 Bomber: 28–29 klik / Comandante C40: 26–28 klik",
        "temperature": "93°C",
        "duration": "4:05–4:35",
        "steps_html": "<li><strong>0:00–0:40 / 55 g</strong> blooming.</li><li><strong>0:40–1:25 / 180 g</strong> yavaş dök.</li><li><strong>1:25–2:20 / 310 g</strong> devam et.</li><li><strong>2:20–3:10 / 400 g</strong> tamamla.</li>",
        "note": "Daha parlak, temiz ve zarif Antigua yorumu."
      },
      {
        "key": "aeropress",
        "label": "Aeropress",
        "ratio": "16.5 g kahve / 215 g su",
        "grind": "MHW-3 Bomber: 23 klik / Comandante C40: 20 klik",
        "temperature": "92°C",
        "duration": "1:45–1:55",
        "steps_html": "<li><strong>0:00–0:20 / 60 g</strong> su ekle ve 4 kez karıştır.</li><li><strong>0:20–0:45 / 215 g</strong> suyu tamamla.</li><li><strong>0:45–1:25</strong> bekle.</li><li><strong>1:25–1:55</strong> bastır.</li>",
        "note": "Tatlılığı ve gövdeyi öne çıkarır."
      },
      {
        "key": "filtre-makinesi",
        "label": "Filtre Kahve Makinesi",
        "ratio": "32 g kahve / 500 g su",
        "grind": "MHW-3 Bomber: 27–29 klik / Comandante C40: 25–28 klik",
        "temperature": "92–93°C",
        "duration": "Makine döngüsü",
        "steps_html": "<li>Filtreyi durula.</li><li>32 g kahveyi yatağa eşit yay.</li><li>Makinede blooming varsa ilk 65 g suyla 30 saniye beklet.</li><li>500 g suyla demlemeyi tamamla.</li>",
        "note": "Günlük kullanımda tatlı, dengeli ve temiz sonuç verir."
      }
    ]
  },
  "guatemala-antigua-shb-250g": {
    "profile": "Bitter çikolata • Karamel • Tatlı baharat • Narenciye",
    "equipment": "Espresso, V60, French Press, AeroPress",
    "methods": [
      "espresso",
      "v60",
      "frenchpress",
      "aeropress"
    ],
    "recipes": [
      {
        "key": "espresso",
        "label": "Espresso",
        "ratio": "18 g kahve / 38 g çıktı (1:2,1)",
        "grind": "Espresso inceliği. MHW-3 Bomber: espresso ayarı / Comandante C40: 8–10 klik",
        "temperature": "93°C",
        "duration": "27–31 saniye",
        "steps_html": "<li>Dağıt, düz tamp.</li><li><strong>27–31 sn / 38 g</strong> çıktı.</li>",
        "note": "Hedef: bitter çikolata ve karamel, hafif narenciye bitiş.",
        "adjust": [
          [
            "Acı",
            "40 g’a uzat."
          ],
          [
            "Ekşi",
            "Bir kademe incelt."
          ]
        ]
      },
      {
        "key": "v60",
        "label": "V60",
        "ratio": "15 g kahve / 250 g su (1:16,7)",
        "grind": "Orta-ince. MHW-3 Bomber: 23–24 klik / Comandante C40: 21–22 klik",
        "temperature": "94°C",
        "duration": "3:00–3:25",
        "steps_html": "<li><strong>0:00 / 30 g</strong> bloom, 45 saniye (yoğun SHB çekirdek).</li><li><strong>0:45 / 130 g · 1:20 / 200 g · 1:55 / 250 g</strong> kontrollü döküşler.</li><li>Son döküş sonrası hafif swirl.</li>",
        "note": "Yoğun çekirdek için yüksek ısı ve uzun bloom: karamel ve baharat açılır.",
        "adjust": [
          [
            "Ekşi",
            "Bir kademe incelt."
          ],
          [
            "Kuru",
            "Kalınlaştır."
          ]
        ]
      },
      {
        "key": "frenchpress",
        "label": "French Press",
        "ratio": "20 g kahve / 300 g su (1:15)",
        "grind": "Kalın. MHW-3 Bomber: 34–35 klik / Comandante C40: 31–33 klik",
        "temperature": "95°C",
        "duration": "4:00 + 4:00 çökelme",
        "steps_html": "<li><strong>0:00 / 300 g</strong> suyu dök.</li><li><strong>4:00</strong> kabuğu kır, köpüğü al.</li><li><strong>4:00–8:00</strong> çökelmeye bırak.</li><li>Pistonu yüzeye indir, yavaş dök.</li>",
        "note": "Daha sıkı oran ve yüksek ısı: bitter çikolata ve baharat tam gövdeli.",
        "adjust": [
          [
            "Ağır",
            "1:16’ya aç."
          ],
          [
            "Çamurlu",
            "Çökelmeyi uzat."
          ]
        ]
      },
      {
        "key": "aeropress",
        "label": "AeroPress",
        "ratio": "16 g kahve / 210 g su (1:13)",
        "grind": "Orta-ince. MHW-3 Bomber: 21–22 klik / Comandante C40: 18–20 klik",
        "temperature": "93°C",
        "duration": "1:50–2:00",
        "steps_html": "<li><strong>0:00 / 55 g</strong> su, 4 kez karıştır.</li><li><strong>0:20 / 210 g</strong> tamamla, pistonu tak.</li><li><strong>1:35–2:00</strong> bastır.</li>",
        "note": "Kısa ve yoğun: karamel ve kakao.",
        "adjust": [
          [
            "Ekşi",
            "Beklemeyi uzat."
          ]
        ]
      }
    ]
  },
  "colombia-huila-supremo": {
    "profile": "Karamel • Kırmızı meyve • Narenciye • Sütlü çikolata",
    "equipment": "V60, Espresso, AeroPress, Chemex",
    "methods": [
      "v60",
      "espresso",
      "aeropress",
      "chemex"
    ],
    "recipes": [
      {
        "key": "v60",
        "label": "V60",
        "ratio": "15,5 g kahve / 250 g su (1:16)",
        "grind": "Orta-ince. MHW-3 Bomber: 24–25 klik / Comandante C40: 22–23 klik",
        "temperature": "93°C",
        "duration": "2:50–3:10",
        "steps_html": "<li><strong>0:00 / 35 g</strong> bloom, 35 saniye.</li><li><strong>0:35 / 150 g</strong> tek güçlü ana döküş.</li><li><strong>1:10 / 250 g</strong> tamamla; yatağı hafifçe düzle.</li><li><strong>2:50–3:10</strong> bitiş.</li>",
        "note": "Hedef: karamel gövde üstünde kırmızı meyve ve narenciye.",
        "adjust": [
          [
            "Ekşi",
            "Bir kademe incelt."
          ],
          [
            "Kuru",
            "Bir kademe kalınlaştır."
          ]
        ]
      },
      {
        "key": "espresso",
        "label": "Espresso",
        "ratio": "18 g kahve / 40 g çıktı (1:2,2)",
        "grind": "Espresso inceliği. MHW-3 Bomber: espresso ayarı / Comandante C40: 8–10 klik",
        "temperature": "93°C",
        "duration": "28–31 saniye",
        "steps_html": "<li>Dağıt, düz tamp.</li><li><strong>28–31 sn / 40 g</strong> çıktı.</li>",
        "note": "Karamel ve sütlü çikolata öne çıkan, meyvesi temiz bir shot.",
        "adjust": [
          [
            "Ekşi",
            "Bir kademe incelt."
          ],
          [
            "Acı",
            "42 g’a uzat."
          ]
        ]
      },
      {
        "key": "aeropress",
        "label": "AeroPress",
        "ratio": "16 g kahve / 225 g su (1:14)",
        "grind": "Orta-ince. MHW-3 Bomber: 22–23 klik / Comandante C40: 19–21 klik",
        "temperature": "92°C",
        "duration": "1:45–2:00",
        "steps_html": "<li><strong>0:00 / 60 g</strong> su, 3 kez karıştır.</li><li><strong>0:20 / 225 g</strong> tamamla, pistonu tak.</li><li><strong>1:20–1:50</strong> bastır.</li>",
        "note": "Daha yuvarlak, sütlü çikolata ağırlıklı bir fincan.",
        "adjust": [
          [
            "Ekşi",
            "Beklemeyi uzat."
          ]
        ]
      },
      {
        "key": "chemex",
        "label": "Chemex",
        "ratio": "30 g kahve / 500 g su (1:16,7)",
        "grind": "Orta. MHW-3 Bomber: 28–29 klik / Comandante C40: 26–27 klik",
        "temperature": "93°C",
        "duration": "4:10–4:40",
        "steps_html": "<li><strong>0:00 / 70 g</strong> bloom.</li><li><strong>0:45 / 300 g</strong> döküş.</li><li><strong>1:45 / 500 g</strong> tamamla.</li>",
        "note": "Paylaşmak için: temiz, karamel-narenciye dengesi.",
        "adjust": [
          [
            "Uzun süzülüyor",
            "Kalınlaştır."
          ]
        ]
      }
    ]
  },
  "colombia-excelso": {
    "profile": "Temiz içim • Orta asidite • Dengeli gövde",
    "equipment": "V60, Chemex, Aeropress, Filtre Kahve Makinesi",
    "methods": [
      "v60",
      "chemex",
      "aeropress",
      "filtre-makinesi"
    ],
    "recipes": [
      {
        "key": "v60",
        "label": "V60",
        "ratio": "15 g kahve / 240 g su",
        "grind": "MHW-3 Bomber: 25–26 klik / Comandante C40: 22–24 klik",
        "temperature": "92°C",
        "duration": "2:35–2:55",
        "steps_html": "<li><strong>0:00–0:30 / 30 g</strong> blooming.</li><li><strong>0:30–1:00 / 110 g</strong> sakin ilk döküş.</li><li><strong>1:00–1:35 / 180 g</strong> ikinci döküş.</li><li><strong>1:35–2:00 / 240 g</strong> tamamla.</li>",
        "note": "Excelso’da hedef temiz içim; süreyi kısa, oranı biraz daha kompakt tutuyoruz."
      },
      {
        "key": "chemex",
        "label": "Chemex",
        "ratio": "24 g kahve / 390 g su",
        "grind": "MHW-3 Bomber: 29–30 klik / Comandante C40: 27–29 klik",
        "temperature": "93°C",
        "duration": "4:00–4:25",
        "steps_html": "<li><strong>0:00–0:40 / 48 g</strong> blooming.</li><li><strong>0:40–1:25 / 170 g</strong> dök.</li><li><strong>1:25–2:20 / 300 g</strong> devam et.</li><li><strong>2:20–3:05 / 390 g</strong> tamamla.</li>",
        "note": "Daha temiz, daha hafif gövdeli fincan."
      },
      {
        "key": "aeropress",
        "label": "Aeropress",
        "ratio": "15.5 g kahve / 220 g su",
        "grind": "MHW-3 Bomber: 24–25 klik / Comandante C40: 21–22 klik",
        "temperature": "91–92°C",
        "duration": "1:35–1:50",
        "steps_html": "<li><strong>0:00–0:15 / 50 g</strong> su ekle.</li><li><strong>0:15–0:45 / 220 g</strong> tamamla.</li><li><strong>0:45–1:20</strong> bekle.</li><li><strong>1:20–1:50</strong> bastır.</li>",
        "note": "Temiz ve dengeli hızlı fincan."
      },
      {
        "key": "filtre-makinesi",
        "label": "Filtre Kahve Makinesi",
        "ratio": "30 g kahve / 500 g su",
        "grind": "MHW-3 Bomber: 28–30 klik / Comandante C40: 26–29 klik",
        "temperature": "92°C",
        "duration": "Makine döngüsü",
        "steps_html": "<li>Filtreyi durula.</li><li>30 g kahveyi eşit yay.</li><li>500 g suyla demlemeyi başlat.</li><li>Demleme sonrası karafı çalkala.</li>",
        "note": "Makinede stabil ve temiz sonuç verir."
      }
    ]
  },
  "ethiopia-sidamo-250g": {
    "profile": "Meyvemsi • Canlı asidite • Aromatik fincan",
    "equipment": "V60, Chemex, Aeropress, Cold Brew",
    "methods": [
      "v60",
      "chemex",
      "aeropress",
      "coldbrew"
    ],
    "recipes": [
      {
        "key": "v60",
        "label": "V60",
        "ratio": "14.5 g kahve / 250 g su",
        "grind": "MHW-3 Bomber: 26–27 klik / Comandante C40: 23–25 klik",
        "temperature": "94°C",
        "duration": "3:00–3:25",
        "steps_html": "<li><strong>0:00–0:40 / 35 g</strong> blooming; yatağı fazla karıştırma.</li><li><strong>0:40–1:15 / 120 g</strong> yavaş ve ince dök.</li><li><strong>1:15–1:55 / 190 g</strong> devam et.</li><li><strong>1:55–2:25 / 250 g</strong> tamamla.</li>",
        "note": "Meyvemsi ve aromatik karakter için daha yüksek sıcaklık, daha hafif doz ve sakin döküş."
      },
      {
        "key": "chemex",
        "label": "Chemex",
        "ratio": "23 g kahve / 400 g su",
        "grind": "MHW-3 Bomber: 30–31 klik / Comandante C40: 28–30 klik",
        "temperature": "94°C",
        "duration": "4:20–4:55",
        "steps_html": "<li><strong>0:00–0:45 / 50 g</strong> blooming.</li><li><strong>0:45–1:35 / 175 g</strong> yavaş dök.</li><li><strong>1:35–2:40 / 315 g</strong> devam et.</li><li><strong>2:40–3:30 / 400 g</strong> tamamla.</li>",
        "note": "Meyvemsi karakteri daha berrak gösterir."
      },
      {
        "key": "aeropress",
        "label": "Aeropress",
        "ratio": "15 g kahve / 220 g su",
        "grind": "MHW-3 Bomber: 24–25 klik / Comandante C40: 21–22 klik",
        "temperature": "93°C",
        "duration": "1:35–1:45",
        "steps_html": "<li><strong>0:00–0:15 / 45 g</strong> su ekle.</li><li><strong>0:15–0:45 / 220 g</strong> suyu tamamla.</li><li><strong>0:45–1:15</strong> bekle.</li><li><strong>1:15–1:45</strong> bastır.</li>",
        "note": "Canlı ve aromatik fincan verir."
      },
      {
        "key": "coldbrew",
        "label": "Cold Brew",
        "ratio": "38 g kahve / 420 g su",
        "grind": "MHW-3 Bomber: 37–39 klik / Comandante C40: 36–39 klik",
        "temperature": "Soğuk / oda sıcaklığı",
        "duration": "10–12 saat",
        "steps_html": "<li><strong>0:00</strong> kahve ve suyu birleştir.</li><li><strong>0:00–1:00</strong> tüm kahvenin ıslandığından emin ol.</li><li><strong>10–12 saat</strong> buzdolabında beklet.</li><li>Kağıt filtreyle süz.</li>",
        "note": "Ferah, meyvemsi ve çay benzeri cold brew."
      }
    ]
  },
  "ethiopia-yirgacheffe": {
    "profile": "Yasemin • Bergamot • Limon çayı • Berrak",
    "equipment": "V60, Chemex, Japanese Iced",
    "methods": [
      "v60",
      "chemex",
      "japanese"
    ],
    "recipes": [
      {
        "key": "v60",
        "label": "V60",
        "ratio": "14 g kahve / 240 g su (1:17)",
        "grind": "Orta-ince. MHW-3 Bomber: 24–25 klik / Comandante C40: 21–23 klik",
        "temperature": "94°C",
        "duration": "3:00–3:20",
        "steps_html": "<li><strong>0:00 / 35 g</strong> bloom, 45 saniye; çok nazik dök.</li><li><strong>0:45 / 110 g · 1:20 / 180 g · 2:00 / 240 g</strong> yavaş döküşler.</li><li>Swirl yok; çay gibi berrak kalsın.</li>",
        "note": "Hedef: yasemin ve bergamot aroması, limon çayı gibi temiz bir fincan. Uzun oran çay benzeri dokuyu korur.",
        "adjust": [
          [
            "İnce / sulu",
            "1:16’ya sıkılaştır."
          ],
          [
            "Ekşi",
            "Bir kademe incelt."
          ]
        ]
      },
      {
        "key": "chemex",
        "label": "Chemex",
        "ratio": "28 g kahve / 480 g su (1:17)",
        "grind": "Orta. MHW-3 Bomber: 28–29 klik / Comandante C40: 25–27 klik",
        "temperature": "94°C",
        "duration": "4:15–4:45",
        "steps_html": "<li><strong>0:00 / 60 g</strong> bloom, 45 saniye.</li><li><strong>0:45 / 220 g · 1:45 / 360 g · 2:30 / 480 g</strong> sakin döküşler.</li>",
        "note": "Kalın filtre en berrak versiyonu verir: yasemin ve bergamot net.",
        "adjust": [
          [
            "Uzun süzülüyor",
            "Kalınlaştır."
          ]
        ]
      },
      {
        "key": "japanese",
        "label": "Japanese Iced",
        "ratio": "20 g kahve / 160 g sıcak su + 100 g buz",
        "grind": "Orta-ince. MHW-3 Bomber: 22–23 klik / Comandante C40: 20–21 klik",
        "temperature": "94°C",
        "duration": "2:20–2:40",
        "steps_html": "<li>Server’a <strong>100 g</strong> buz koy.</li><li><strong>0:00 / 45 g</strong> bloom.</li><li><strong>0:40 / 110 g · 1:10 / 160 g</strong> iki döküş.</li><li>Bitince buzu erit.</li>",
        "note": "Soğukta bergamot ve limon çayı çok canlı.",
        "adjust": [
          [
            "Sulu",
            "Buzu 80 g’a düşür."
          ]
        ]
      }
    ]
  },
  "colombia-huila-la-bonita-anaerobic": {
    "profile": "Kompleks meyvemsi yapı • Yüksek asidite • Parlak fincan",
    "equipment": "V60, Aeropress, Chemex, Cold Brew",
    "methods": [
      "v60",
      "aeropress",
      "chemex",
      "coldbrew"
    ],
    "recipes": [
      {
        "key": "v60",
        "label": "V60",
        "ratio": "15 g kahve / 240 g su",
        "grind": "MHW-3 Bomber: 24–25 klik / Comandante C40: 21–23 klik",
        "temperature": "91–92°C",
        "duration": "2:45–3:05",
        "steps_html": "<li><strong>0:00–0:45 / 40 g</strong> blooming; gaz çıkışını bekle.</li><li><strong>0:45–1:15 / 115 g</strong> çok sakin ilk döküş.</li><li><strong>1:15–1:50 / 180 g</strong> ikinci döküş.</li><li><strong>1:50–2:15 / 240 g</strong> tamamla.</li>",
        "note": "Anaerobic karakteri ağırlaştırmamak için daha düşük sıcaklık, daha az su ve az ajitasyon."
      },
      {
        "key": "aeropress",
        "label": "Aeropress",
        "ratio": "15 g kahve / 205 g su",
        "grind": "MHW-3 Bomber: 23–24 klik / Comandante C40: 20–21 klik",
        "temperature": "90–91°C",
        "duration": "1:25–1:40",
        "steps_html": "<li><strong>0:00–0:15 / 45 g</strong> su ekle.</li><li><strong>0:15–0:40 / 205 g</strong> tamamla.</li><li><strong>0:40–1:10</strong> bekle.</li><li><strong>1:10–1:40</strong> bastır.</li>",
        "note": "Kısa temas, yoğun meyvemsi ama temiz sonuç verir."
      },
      {
        "key": "chemex",
        "label": "Chemex",
        "ratio": "23 g kahve / 370 g su",
        "grind": "MHW-3 Bomber: 28–30 klik / Comandante C40: 26–29 klik",
        "temperature": "91–92°C",
        "duration": "3:55–4:25",
        "steps_html": "<li><strong>0:00–0:45 / 50 g</strong> blooming.</li><li><strong>0:45–1:30 / 165 g</strong> sakin dök.</li><li><strong>1:30–2:25 / 285 g</strong> devam et.</li><li><strong>2:25–3:10 / 370 g</strong> tamamla.</li>",
        "note": "Kompleksliği berraklaştırır, fermente algıyı dengeler."
      },
      {
        "key": "coldbrew",
        "label": "Cold Brew",
        "ratio": "34 g kahve / 400 g su",
        "grind": "MHW-3 Bomber: 37–39 klik / Comandante C40: 36–39 klik",
        "temperature": "Soğuk / oda sıcaklığı",
        "duration": "7–9 saat",
        "steps_html": "<li><strong>0:00</strong> kahve ve suyu birleştir.</li><li><strong>0:00–1:00</strong> tüm kahvenin ıslandığından emin ol.</li><li><strong>7–9 saat</strong> buzdolabında beklet.</li><li>Süreyi uzatma; kağıt filtreyle süz.</li>",
        "note": "Anaerobic tatların ağırlaşmaması için cold brew süresi kısa tutuldu."
      }
    ]
  },
  "rwanda-nyamasheke-anaerobic": {
    "profile": "Meyvemsi • Parlak asidite • Karamel tatlılığı",
    "equipment": "V60, Origami, AeroPress, Japanese Iced",
    "methods": [
      "v60",
      "origami",
      "aeropress",
      "japanese"
    ],
    "recipes": [
      {
        "key": "v60",
        "label": "V60",
        "ratio": "15 g kahve / 235 g su (1:15,7)",
        "grind": "Orta-ince. MHW-3 Bomber: 25–26 klik / Comandante C40: 22–24 klik",
        "temperature": "91°C",
        "duration": "2:40–3:00",
        "steps_html": "<li><strong>0:00–0:40 / 35 g</strong> bloom.</li><li><strong>0:40–1:10 / 115 g</strong> sakin dök.</li><li><strong>1:15–1:45 / 180 g</strong> devam et.</li><li><strong>1:50–2:10 / 235 g</strong> tamamla.</li><li><strong>2:40–3:00</strong> süzülme bitsin.</li>",
        "note": "Kivi ve narenciye parlak, frambuaz ve karamel tatlı; düşük sıcaklık fermente algıyı dengede tutar.",
        "adjust": [
          [
            "Şarapsı / ağır",
            "89°C’ye in."
          ],
          [
            "Fazla ekşi",
            "Bir kademe incelt."
          ],
          [
            "Karamel geride",
            "Oranı 15 g / 225 g’a sıkılaştır."
          ]
        ]
      },
      {
        "key": "origami",
        "label": "Origami",
        "ratio": "16 g kahve / 250 g su (1:15,6)",
        "grind": "Orta. MHW-3 Bomber: 26–27 klik / Comandante C40: 23–25 klik",
        "temperature": "91°C",
        "duration": "2:30–2:50",
        "steps_html": "<li>Origami’yi <strong>konik kağıt filtre</strong> ile kullan.</li><li><strong>0:00–0:40 / 45 g</strong> bloom.</li><li><strong>0:40–1:00 / 130 g</strong> döküş.</li><li><strong>1:10–1:30 / 250 g</strong> tamamla.</li><li><strong>2:30–2:50</strong> süzülme bitsin.</li>",
        "note": "Hızlı akış kivi ve narenciyeyi daha berrak ve canlı gösterir.",
        "adjust": [
          [
            "Çok hızlı / ince",
            "Bir kademe incelt."
          ],
          [
            "Fermente",
            "89°C’ye in."
          ]
        ]
      },
      {
        "key": "aeropress",
        "label": "AeroPress",
        "ratio": "15 g kahve / 210 g su (1:14)",
        "grind": "Orta-ince. MHW-3 Bomber: 23–24 klik / Comandante C40: 20–21 klik",
        "temperature": "90°C",
        "duration": "1:30–1:45",
        "steps_html": "<li><strong>0:00–0:15 / 45 g</strong> su ekle.</li><li><strong>0:15–0:40 / 210 g</strong> tamamla.</li><li><strong>0:40–1:15</strong> bekle.</li><li><strong>1:15–1:45</strong> bastır.</li>",
        "note": "Karamel ve frambuaz tarafı daha dolgun; parlak ama kontrollü bir fincan.",
        "adjust": [
          [
            "Ağır",
            "88°C’ye in."
          ],
          [
            "Zayıf",
            "Kahveyi 16 g’a çıkar."
          ]
        ]
      },
      {
        "key": "japanese",
        "label": "Japanese Iced",
        "ratio": "20 g kahve / 160 g sıcak su + 100 g buz",
        "grind": "Orta-ince. MHW-3 Bomber: 23–24 klik / Comandante C40: 20–22 klik",
        "temperature": "91°C",
        "duration": "2:20–2:40",
        "steps_html": "<li>Server’a <strong>100 g</strong> iri buz koy.</li><li><strong>0:00–0:40 / 45 g</strong> bloom.</li><li><strong>0:40–1:05 / 110 g</strong> döküş.</li><li><strong>1:10–1:30 / 160 g</strong> tamamla; server’ı çevirerek buzu erit.</li>",
        "note": "Soğukta kivi ve frambuaz daha sulu; karamel bitiş tatlı kalır.",
        "adjust": [
          [
            "Sulu",
            "Buzu 80 g’a düşür."
          ],
          [
            "Kapalı",
            "Bir kademe incelt."
          ]
        ]
      }
    ]
  },
  "peru-shb-grade-1-250g": {
    "profile": "Tatlı • Canlı ve yumuşak asidite • Orta gövde",
    "equipment": "V60, Chemex, AeroPress, Filtre Kahve Makinesi",
    "methods": [
      "v60",
      "chemex",
      "aeropress",
      "filtre-makinesi"
    ],
    "recipes": [
      {
        "key": "v60",
        "label": "V60",
        "ratio": "15 g kahve / 250 g su",
        "grind": "MHW-3 Bomber: 24–25 klik / Comandante C40: 21–23 klik",
        "temperature": "93°C",
        "duration": "2:45–3:05",
        "steps_html": "<li><strong>0:00–0:40 / 35 g</strong> blooming; yatağın tamamını ıslat.</li><li><strong>0:40–1:15 / 125 g</strong> sakin dairelerle dök.</li><li><strong>1:15–1:50 / 195 g</strong> ikinci döküşte akışı dengede tut.</li><li><strong>1:50–2:15 / 250 g</strong> tamamla ve çok hafif swirl yap.</li>",
        "note": "Sütlü çikolata ve karamel tatlılığını korurken portakal ile kırmızı elma canlılığını temiz gösterecek dengeli başlangıç reçetesi."
      },
      {
        "key": "chemex",
        "label": "Chemex",
        "ratio": "24 g kahve / 400 g su",
        "grind": "MHW-3 Bomber: 28–29 klik / Comandante C40: 25–27 klik",
        "temperature": "93°C",
        "duration": "4:00–4:25",
        "steps_html": "<li><strong>0:00–0:45 / 55 g</strong> blooming.</li><li><strong>0:45–1:35 / 180 g</strong> geniş ve yavaş dairelerle dök.</li><li><strong>1:35–2:25 / 300 g</strong> ikinci ana döküşü yap.</li><li><strong>2:25–3:10 / 400 g</strong> tamamla ve yatağı kendi halinde süzülmeye bırak.</li>",
        "note": "Chemex, bal ve esmer şeker tatlılığını korurken elma ve portakal tarafını daha berrak gösterir."
      },
      {
        "key": "aeropress",
        "label": "AeroPress",
        "ratio": "16 g kahve / 230 g su",
        "grind": "MHW-3 Bomber: 21–22 klik / Comandante C40: 18–20 klik",
        "temperature": "92°C",
        "duration": "1:50–2:05",
        "steps_html": "<li><strong>0:00–0:20 / 55 g</strong> su ekle ve 3 kez karıştır.</li><li><strong>0:20–0:50 / 230 g</strong> suyu tamamla.</li><li><strong>0:50–1:25</strong> bekle.</li><li><strong>1:25–2:05</strong> yavaş ve kontrollü bastır.</li>",
        "note": "Badem, sütlü çikolata ve karamel tarafını biraz daha dolgun; meyve canlılığını ise yumuşak tutar."
      },
      {
        "key": "filtre-makinesi",
        "label": "Filtre Kahve Makinesi",
        "ratio": "30 g kahve / 500 g su",
        "grind": "MHW-3 Bomber: 27–29 klik / Comandante C40: 25–27 klik",
        "temperature": "92–93°C",
        "duration": "Makine döngüsü",
        "steps_html": "<li>Kağıt filtreyi durula.</li><li>30 g kahveyi yatağa eşit dağıt.</li><li>Blooming özelliği varsa ilk 60 g suyla 30–35 saniye beklet.</li><li>500 g suyla demlemeyi tamamla.</li><li>Servisten önce karafı nazikçe çalkala.</li>",
        "note": "Günlük kullanımda tatlı, temiz ve dengeli sonuç; sütlü çikolata ile kırmızı elma arasında rahat bir fincan."
      }
    ]
  },
  "honduras-shg": {
    "profile": "Fındık • Kakao • Karamel • Yumuşak meyve",
    "equipment": "V60, Chemex, Espresso, French Press",
    "methods": [
      "v60",
      "chemex",
      "espresso",
      "frenchpress"
    ],
    "recipes": [
      {
        "key": "v60",
        "label": "V60",
        "ratio": "15 g kahve / 240 g su (1:16)",
        "grind": "Orta-ince. MHW-3 Bomber: 24–25 klik / Comandante C40: 22–23 klik",
        "temperature": "93°C",
        "duration": "2:50–3:10",
        "steps_html": "<li><strong>0:00 / 40 g</strong> bloom, 40 saniye.</li><li><strong>0:40 / 140 g</strong> döküş.</li><li><strong>1:20 / 240 g</strong> tamamla, hafif swirl.</li>",
        "note": "Hedef: fındık ve kakao tatlılığı, yumuşak meyveyle dengeli günlük fincan.",
        "adjust": [
          [
            "Düz",
            "Bir kademe incelt."
          ],
          [
            "Kuru",
            "Kalınlaştır."
          ]
        ]
      },
      {
        "key": "chemex",
        "label": "Chemex",
        "ratio": "30 g kahve / 480 g su (1:16)",
        "grind": "Orta. MHW-3 Bomber: 28–29 klik / Comandante C40: 26–28 klik",
        "temperature": "93°C",
        "duration": "4:10–4:35",
        "steps_html": "<li><strong>0:00 / 70 g</strong> bloom.</li><li><strong>0:45 / 280 g</strong> döküş.</li><li><strong>1:45 / 480 g</strong> tamamla.</li>",
        "note": "Paylaşmak için temiz, karamel ağırlıklı sürahi.",
        "adjust": [
          [
            "Uzun",
            "Kalınlaştır."
          ]
        ]
      },
      {
        "key": "espresso",
        "label": "Espresso",
        "ratio": "18 g kahve / 40 g çıktı (1:2,2)",
        "grind": "Espresso inceliği. MHW-3 Bomber: espresso ayarı / Comandante C40: 8–10 klik",
        "temperature": "92–93°C",
        "duration": "27–30 saniye",
        "steps_html": "<li>Dağıt, düz tamp.</li><li><strong>27–30 sn / 40 g</strong> çıktı.</li>",
        "note": "Fındık ve kakao, sütle de dengeli.",
        "adjust": [
          [
            "Acı",
            "42 g’a uzat."
          ],
          [
            "Ekşi",
            "İncelt."
          ]
        ]
      },
      {
        "key": "frenchpress",
        "label": "French Press",
        "ratio": "18 g kahve / 300 g su (1:16,7)",
        "grind": "Kalın. MHW-3 Bomber: 34–36 klik / Comandante C40: 32–34 klik",
        "temperature": "93°C",
        "duration": "4:00 + 5:00 çökelme",
        "steps_html": "<li><strong>0:00 / 300 g</strong> suyu dök.</li><li><strong>4:00</strong> kabuğu kır, köpüğü al.</li><li><strong>4:00–9:00</strong> çökelmeye bırak.</li><li>Pistonu yüzeye indir, yavaş dök.</li>",
        "note": "Uzun çökelme: fındık ve karamel temiz, gövde yumuşak.",
        "adjust": [
          [
            "Çamurlu",
            "Çökelmeyi uzat."
          ]
        ]
      }
    ]
  },
  "honduras-finca-el-jardin-anaerobic": {
    "profile": "Canlı ve katmanlı • Yüksek asidite • Temiz özel işlem",
    "equipment": "V60, Origami, AeroPress, Japanese Iced, Espresso (sütlü içimler)",
    "methods": [
      "v60",
      "origami",
      "aeropress",
      "japanese",
      "espresso"
    ],
    "recipes": [
      {
        "key": "v60",
        "label": "V60",
        "ratio": "15 g kahve / 240 g su (1:16)",
        "grind": "Orta-ince. MHW-3 Bomber: 25–26 klik / Comandante C40: 22–24 klik",
        "temperature": "91°C",
        "duration": "2:45–3:05",
        "steps_html": "<li><strong>0:00–0:45 / 40 g</strong> bloom; yatağı tamamen ıslat.</li><li><strong>0:45–1:10 / 120 g</strong> merkez ağırlıklı döküş.</li><li><strong>1:20–1:45 / 185 g</strong> ince ve kontrollü devam et.</li><li><strong>1:55–2:15 / 240 g</strong> tamamla; çok hafif swirl.</li><li><strong>2:45–3:05</strong> süzülme bitsin.</li>",
        "note": "Limonlu tart ve bektaşi üzümü canlılığını koruyup vanilya tatlılığını bitişe taşıyan temiz bir fincan.",
        "adjust": [
          [
            "Fazla ekşi",
            "Bir kademe incelt."
          ],
          [
            "Fermente",
            "89–90°C’ye in."
          ],
          [
            "Vanilya geride",
            "Oranı 15 g / 230 g’a sıkılaştır."
          ]
        ]
      },
      {
        "key": "origami",
        "label": "Origami",
        "ratio": "15 g kahve / 235 g su (1:15,7)",
        "grind": "Orta-ince. MHW-3 Bomber: 26–27 klik / Comandante C40: 23–25 klik",
        "temperature": "91°C",
        "duration": "2:35–2:55",
        "steps_html": "<li>Origami’yi <strong>dalgalı (wave) filtre</strong> ile kullan.</li><li><strong>0:00–0:40 / 40 g</strong> bloom.</li><li><strong>0:40–1:00 / 125 g</strong> döküş.</li><li><strong>1:10–1:30 / 235 g</strong> tamamla.</li><li><strong>2:35–2:55</strong> süzülme bitsin.</li>",
        "note": "Düz yatak vanilya ve tart hamuru tatlılığını öne çıkarır; asidite daha yuvarlak.",
        "adjust": [
          [
            "Düz",
            "Bir kademe incelt."
          ],
          [
            "Keskin",
            "Oranı 15 g / 225 g’a sıkılaştır."
          ]
        ]
      },
      {
        "key": "aeropress",
        "label": "AeroPress",
        "ratio": "15 g kahve / 210 g su (1:14)",
        "grind": "Orta-ince. MHW-3 Bomber: 23–24 klik / Comandante C40: 20–21 klik",
        "temperature": "90°C",
        "duration": "1:30–1:45",
        "steps_html": "<li><strong>0:00–0:15 / 45 g</strong> su ekle ve yatağı tamamen ıslat.</li><li><strong>0:15–0:40 / 210 g</strong> suyu tamamla.</li><li><strong>0:40–1:15</strong> bekle; kısa bir karıştırma.</li><li><strong>1:15–1:45</strong> sabit ve yavaş bastır.</li>",
        "note": "Kısa temas; bektaşi üzümü canlılığını korurken vanilyayı daha dolgun hissettirir.",
        "adjust": [
          [
            "Fazla ekşi",
            "Bekleme süresini 20 saniye uzat."
          ],
          [
            "Ağır",
            "88°C’ye in."
          ]
        ]
      },
      {
        "key": "japanese",
        "label": "Japanese Iced",
        "ratio": "20 g kahve / 180 g sıcak su + 120 g buz",
        "grind": "Orta-ince. MHW-3 Bomber: 24–25 klik / Comandante C40: 21–23 klik",
        "temperature": "91°C",
        "duration": "2:30–2:50",
        "steps_html": "<li>Server’a <strong>120 g</strong> iri buz koy.</li><li><strong>0:00–0:40 / 50 g</strong> bloom.</li><li><strong>0:40–1:20 / 120 g</strong> kontrollü dök.</li><li><strong>1:20–1:55 / 180 g</strong> tamamla; server’ı çevirerek buzu erit.</li>",
        "note": "Parlak meyve asiditesini serin ve temiz gösterir; limonlu tart soğukta daha belirgin.",
        "adjust": [
          [
            "Sulu",
            "Buzu 100 g’a düşür."
          ],
          [
            "Kapalı aroma",
            "Bir kademe incelt."
          ]
        ]
      },
      {
        "key": "espresso",
        "label": "Espresso · sütlü içimler",
        "ratio": "18 g kahve / 40 g çıktı (1:2,2)",
        "grind": "Espresso inceliği. MHW-3 Bomber: espresso ayarı / Comandante C40: 8–10 klik",
        "temperature": "94°C",
        "duration": "28–32 saniye",
        "steps_html": "<li>Bu reçete özellikle sütlü içimler için tasarlandı: flat white, cortado, cappuccino.</li><li>18 g kahveyi dağıt, düz tamp yap. E61 gruplu makinelerde ilk saniyelerdeki yavaş ıslanma doğal ön demlemedir.</li><li><strong>28–32 sn / 40 g</strong> çıktıda durdur; ilk damlalar 8–10 saniyede gelmeli.</li><li>Flat white: 40 g shot + 110–120 g süt. Cortado: 40 g shot + 40 g süt.</li>",
        "note": "Sütte vanilya, limonlu tart hamuru ve yuvarlak meyve tatlılığı öne çıkar. Tek başına shot olarak canlı asiditesi baskın gelebilir; sade espresso için önermiyoruz.",
        "adjust": [
          [
            "Sütte ekşi kalıyor",
            "Bir kademe incelt veya 42 g’a uzat."
          ],
          [
            "Acı / kuru",
            "Bir kademe kalınlaştır."
          ],
          [
            "Sütte kayboluyor",
            "38 g’a kısalt."
          ]
        ]
      }
    ]
  },
  "honduras-finca-el-jardin-anaerobic-250g": {
    "profile": "Limonlu tart • Bektaşi üzümü • Vanilya",
    "equipment": "Origami (dalgalı filtre), V60, Japanese Iced, Espresso (sütlü içimler)",
    "methods": [
      "origami",
      "v60",
      "japanese",
      "espresso"
    ],
    "recipes": [
      {
        "key": "origami",
        "label": "Origami · dalgalı filtre",
        "ratio": "16 g kahve / 256 g su (1:16)",
        "grind": "Orta. MHW-3 Bomber: 25–26 klik / Comandante C40: 22–24 klik",
        "temperature": "91°C",
        "duration": "2:50–3:10",
        "steps_html": "<li>Origami’ye <strong>dalgalı (Kalita Wave 185) filtre</strong> tak.</li><li><strong>0:00 / 50 g</strong> bloom, 40 saniye.</li><li><strong>0:40 / 100 g · 1:10 / 150 g · 1:40 / 200 g · 2:05 / 256 g</strong> dört nabız döküş, hep aynı noktadan.</li><li>Son döküşten sonra hafif bir tap ile yatağı düzle.</li><li><strong>2:50–3:10</strong> bitiş.</li>",
        "note": "Hedef: limonlu tartın tatlı-ekşi dengesi ve uzun vanilya bitişi. Düz yatak tatlılığı ve gövdeyi destekler.",
        "adjust": [
          [
            "Fermente",
            "89°C’ye in."
          ],
          [
            "Vanilya geride",
            "Bir kademe incelt."
          ],
          [
            "Ekşi",
            "Son döküşü 2:15’e geciktir."
          ]
        ]
      },
      {
        "key": "v60",
        "label": "V60",
        "ratio": "15 g kahve / 240 g su (1:16)",
        "grind": "Orta-ince. MHW-3 Bomber: 24–25 klik / Comandante C40: 22–23 klik",
        "temperature": "92°C",
        "duration": "2:40–3:00",
        "steps_html": "<li><strong>0:00 / 45 g</strong> bloom, hafif swirl.</li><li><strong>0:45 / 140 g</strong> döküş.</li><li><strong>1:20 / 240 g</strong> döküş, ardından hafif swirl.</li><li><strong>2:40–3:00</strong> bitiş.</li>",
        "note": "Daha parlak versiyon: limon ve bektaşi üzümü öne gelir.",
        "adjust": [
          [
            "Keskin",
            "Bir kademe kalınlaştır."
          ],
          [
            "Zayıf",
            "Oranı 15 g / 230 g yap."
          ]
        ]
      },
      {
        "key": "japanese",
        "label": "Japanese Iced",
        "ratio": "22 g kahve / 180 g sıcak su + 110 g buz",
        "grind": "Orta-ince. MHW-3 Bomber: 23–24 klik / Comandante C40: 20–22 klik",
        "temperature": "92°C",
        "duration": "2:30–2:50",
        "steps_html": "<li>Server’a <strong>110 g</strong> iri buz koy.</li><li><strong>0:00 / 50 g</strong> bloom.</li><li><strong>0:40 / 120 g · 1:15 / 180 g</strong> iki döküş.</li><li><strong>2:30–2:50</strong> bitince server’ı çevir, buzu erit.</li>",
        "note": "Soğukta limonlu tart ve bektaşi üzümü çok net; vanilya bitişte kalır.",
        "adjust": [
          [
            "Sulu",
            "Buzu 90 g’a düşür."
          ],
          [
            "Kapalı",
            "Bir kademe incelt."
          ]
        ]
      },
      {
        "key": "espresso",
        "label": "Espresso · sütlü içimler",
        "ratio": "18 g kahve / 40 g çıktı (1:2,2)",
        "grind": "Espresso inceliği. MHW-3 Bomber: espresso ayarı / Comandante C40: 8–10 klik",
        "temperature": "94°C",
        "duration": "28–32 saniye",
        "steps_html": "<li>Bu reçete özellikle sütlü içimler için tasarlandı: flat white, cortado, cappuccino.</li><li>18 g kahveyi dağıt, düz tamp yap. E61 gruplu makinelerde ilk saniyelerdeki yavaş ıslanma doğal ön demlemedir.</li><li><strong>28–32 sn / 40 g</strong> çıktıda durdur; ilk damlalar 8–10 saniyede gelmeli.</li><li>Flat white: 40 g shot + 110–120 g süt. Cortado: 40 g shot + 40 g süt.</li>",
        "note": "Sütte vanilya, limonlu tart hamuru ve yuvarlak meyve tatlılığı öne çıkar. Tek başına shot olarak canlı asiditesi baskın gelebilir; sade espresso için önermiyoruz.",
        "adjust": [
          [
            "Sütte ekşi kalıyor",
            "Bir kademe incelt veya 42 g’a uzat."
          ],
          [
            "Acı / kuru",
            "Bir kademe kalınlaştır."
          ],
          [
            "Sütte kayboluyor",
            "38 g’a kısalt."
          ]
        ]
      }
    ]
  },
  "kenya-aa-rung-eto-karimukui-034": {
    "profile": "Sulu asidite • Kırmızı meyve • Berrak ve temiz fincan",
    "equipment": "V60, Origami, Chemex, AeroPress",
    "methods": [
      "v60",
      "origami",
      "chemex",
      "aeropress"
    ],
    "recipes": [
      {
        "key": "v60",
        "label": "V60",
        "ratio": "15 g kahve / 250 g su (1:16,7)",
        "grind": "Orta-ince. MHW-3 Bomber: 23–24 klik / Comandante C40: 21–22 klik",
        "temperature": "95°C",
        "duration": "2:50–3:10",
        "steps_html": "<li><strong>0:00–0:45 / 45 g</strong> bloom; dripper’ı döndürerek bütün yatağı ıslat.</li><li><strong>0:45–1:05 / 100 g</strong> merkezden dışa küçük dairelerle dök.</li><li><strong>1:10–1:30 / 150 g</strong> aynı hızla devam et.</li><li><strong>1:35–1:55 / 200 g</strong> üçüncü döküş.</li><li><strong>2:00–2:15 / 250 g</strong> tamamla; tek hafif swirl ile yatağı düzle.</li><li><strong>2:50–3:10</strong> süzülme bitsin.</li>",
        "note": "Yoğun, yüksek rakım washed çekirdek için sıcak su ve beş kısa döküş: sulu asidite korunur, kırmızı meyve tatlılığı öne gelir.",
        "adjust": [
          [
            "Fazla ekşi / ince",
            "Bir kademe incelt veya bitişi 3:10’a uzat."
          ],
          [
            "Kuru / acı bitiş",
            "Bir kademe kalınlaştır, son swirl’ü atla."
          ],
          [
            "Aromatik ama zayıf",
            "Oranı 15 g / 240 g’a çek."
          ]
        ]
      },
      {
        "key": "origami",
        "label": "Origami",
        "ratio": "15 g kahve / 240 g su (1:16)",
        "grind": "Orta-ince. MHW-3 Bomber: 24–25 klik / Comandante C40: 22–23 klik",
        "temperature": "94°C",
        "duration": "2:40–3:00",
        "steps_html": "<li>Origami’yi <strong>konik kağıt filtre</strong> ile kullan; filtreyi sıcak suyla yıka.</li><li><strong>0:00–0:40 / 40 g</strong> bloom; hafif swirl.</li><li><strong>0:40–1:00 / 120 g</strong> ilk ana döküş.</li><li><strong>1:10–1:30 / 180 g</strong> ikinci döküş.</li><li><strong>1:40–1:55 / 240 g</strong> tamamla.</li><li><strong>2:40–3:00</strong> süzülme bitsin.</li>",
        "note": "Origami’nin hızlı akışı Kenya’yı daha çiçeksi ve berrak gösterir; V60’a göre daha hafif, çay benzeri bir fincan.",
        "adjust": [
          [
            "Fazla ekşi",
            "1°C artır veya bir kademe incelt."
          ],
          [
            "Acı / buruk",
            "Bir kademe kalınlaştır."
          ],
          [
            "Çok hızlı bitiyor",
            "Döküşleri daha yavaş yap, bir kademe incelt."
          ]
        ]
      },
      {
        "key": "chemex",
        "label": "Chemex",
        "ratio": "30 g kahve / 500 g su (1:16,7)",
        "grind": "Orta. MHW-3 Bomber: 29–30 klik / Comandante C40: 26–28 klik",
        "temperature": "95°C",
        "duration": "4:15–4:45",
        "steps_html": "<li>Kalın Chemex filtresini bol sıcak suyla yıka.</li><li><strong>0:00–0:45 / 80 g</strong> bloom; kaşıkla bir kez nazikçe karıştır.</li><li><strong>0:45–1:30 / 220 g</strong> geniş dairelerle dök.</li><li><strong>1:40–2:20 / 360 g</strong> devam et.</li><li><strong>2:30–3:00 / 500 g</strong> tamamla.</li><li><strong>4:15–4:45</strong> süzülme bitsin.</li>",
        "note": "Kalın filtre fincanı çok berrak yapar; kuşburnu ve frenk üzümü asiditesi net ve temiz kalır.",
        "adjust": [
          [
            "Uzun süzülüyor (5:00+)",
            "İki kademe kalınlaştır."
          ],
          [
            "İnce ve sivri",
            "Bloom karıştırmasını koru, bir kademe incelt."
          ],
          [
            "Kuru bitiş",
            "Sıcaklığı 93°C’ye düşür."
          ]
        ]
      },
      {
        "key": "aeropress",
        "label": "AeroPress",
        "ratio": "15 g kahve / 220 g su (1:14,7)",
        "grind": "Orta-ince. MHW-3 Bomber: 21–22 klik / Comandante C40: 18–20 klik",
        "temperature": "93°C",
        "duration": "2:00–2:15",
        "steps_html": "<li>Standart konum; kağıt filtreyi ıslat.</li><li><strong>0:00–0:15 / 220 g</strong> suyu dök.</li><li><strong>0:15–0:25</strong> 3 kez nazikçe karıştır, pistonu hafifçe tak.</li><li><strong>0:25–1:30</strong> bekle.</li><li><strong>1:30</strong> bir swirl yap.</li><li><strong>1:40–2:15</strong> yavaş ve sabit bastır.</li>",
        "note": "Daha dolgun, sulu bir Kenya: kırmızı meyve tatlılığı daha yoğun, asidite daha yuvarlak.",
        "adjust": [
          [
            "Fazla ekşi",
            "Bekleme süresini 30 saniye uzat."
          ],
          [
            "Acı",
            "Bir kademe kalınlaştır, karıştırmayı azalt."
          ],
          [
            "Çok yoğun",
            "Fincana 20–30 g sıcak su ekle."
          ]
        ]
      }
    ]
  },
  "ethiopia-burtukaana-goro-bedesa-1": {
    "profile": "Tart & floral • Parlak meyve • Şekerli tatlılık",
    "equipment": "V60, Origami, AeroPress, Japanese Iced",
    "methods": [
      "v60",
      "origami",
      "aeropress",
      "japanese"
    ],
    "recipes": [
      {
        "key": "v60",
        "label": "V60",
        "ratio": "15 g kahve / 250 g su (1:16,7)",
        "grind": "Orta-ince. MHW-3 Bomber: 24–26 klik / Comandante C40: 22–24 klik",
        "temperature": "93°C",
        "duration": "2:40–3:00",
        "steps_html": "<li><strong>0:00–0:40 / 40 g</strong> bloom; nazik bir swirl.</li><li><strong>0:40–1:05 / 130 g</strong> ilk ana döküş, merkez ağırlıklı.</li><li><strong>1:15–1:40 / 250 g</strong> tamamla; kenarlara su çarptırma.</li><li><strong>1:45</strong> tek hafif swirl.</li><li><strong>2:40–3:00</strong> süzülme bitsin.</li>",
        "note": "Az döküş ve düşük ajitasyon, natural işlemin meyvesini temiz tutar; çiçeksi aroma ile şekerli tatlılık birlikte gelir.",
        "adjust": [
          [
            "Şarapsı / ağır",
            "Sıcaklığı 91°C’ye indir."
          ],
          [
            "Fazla ekşi",
            "Bir kademe incelt."
          ],
          [
            "Kuru / acı",
            "Bir kademe kalınlaştır, son swirl’ü atla."
          ]
        ]
      },
      {
        "key": "origami",
        "label": "Origami",
        "ratio": "16 g kahve / 250 g su (1:15,6)",
        "grind": "Orta. MHW-3 Bomber: 25–27 klik / Comandante C40: 23–25 klik",
        "temperature": "93°C",
        "duration": "2:30–2:50",
        "steps_html": "<li>Origami’yi <strong>dalgalı (wave) filtre</strong> ile kullan; düz yatak tatlılığı artırır.</li><li><strong>0:00–0:40 / 45 g</strong> bloom.</li><li><strong>0:40–1:00 / 110 g</strong> döküş.</li><li><strong>1:10–1:25 / 180 g</strong> döküş.</li><li><strong>1:35–1:50 / 250 g</strong> tamamla.</li><li><strong>2:30–2:50</strong> süzülme bitsin.</li>",
        "note": "Düz tabanlı yatak daha eşit bir ekstraksiyon verir: meyve daha yuvarlak, bitiş daha şekerli.",
        "adjust": [
          [
            "Düz / sıkıcı",
            "Bir kademe incelt."
          ],
          [
            "Fermente hissi",
            "2°C düşür."
          ],
          [
            "Ağır gövde",
            "Oranı 15 g / 250 g’a aç."
          ]
        ]
      },
      {
        "key": "aeropress",
        "label": "AeroPress",
        "ratio": "14 g kahve / 210 g su (1:15)",
        "grind": "Orta-ince. MHW-3 Bomber: 22–23 klik / Comandante C40: 19–21 klik",
        "temperature": "91°C",
        "duration": "1:45–2:00",
        "steps_html": "<li>Standart konum; kağıt filtreyi ıslat.</li><li><strong>0:00–0:10 / 50 g</strong> dök ve 3 kez karıştır.</li><li><strong>0:30–0:40 / 210 g</strong> tamamla, pistonu tak.</li><li><strong>0:40–1:20</strong> bekle.</li><li><strong>1:20–2:00</strong> sabit bastır.</li>",
        "note": "Düşük sıcaklık meyveyi taze tutar; AeroPress fincana daha sulu bir gövde katar.",
        "adjust": [
          [
            "Fazla ekşi",
            "Bekleme süresini 20 saniye uzat."
          ],
          [
            "Şarapsı / ağır",
            "89°C’ye indir."
          ],
          [
            "Zayıf",
            "Kahveyi 15 g’a çıkar."
          ]
        ]
      },
      {
        "key": "japanese",
        "label": "Japanese Iced",
        "ratio": "20 g kahve / 160 g sıcak su + 100 g buz",
        "grind": "Orta-ince, sıcak demlemeden bir kademe ince. MHW-3 Bomber: 22–24 klik / Comandante C40: 20–22 klik",
        "temperature": "93°C",
        "duration": "2:20–2:40",
        "steps_html": "<li>Server’a <strong>100 g</strong> iri buz koy.</li><li><strong>0:00–0:40 / 45 g</strong> bloom.</li><li><strong>0:40–1:10 / 110 g</strong> döküş.</li><li><strong>1:15–1:35 / 160 g</strong> tamamla.</li><li><strong>2:20–2:40</strong> süzülme bittiğinde server’ı çevirerek buzu erit.</li>",
        "note": "Buz üzerine sıcak demleme aromayı hapseder; soğuk fincanda çiçeksi ve parlak meyve öne çıkar.",
        "adjust": [
          [
            "Sulu / zayıf",
            "Bir kademe incelt veya buzu 90 g’a düşür."
          ],
          [
            "Keskin asidite",
            "93°C’yi koru, bloom’u 50 saniyeye uzat."
          ]
        ]
      }
    ]
  },
  "colombia-la-reserva": {
    "profile": "Narin • Hafif gövde • Çiçeksi ve meyveli",
    "equipment": "V60, Origami, Chemex, Japanese Iced",
    "methods": [
      "v60",
      "origami",
      "chemex",
      "japanese"
    ],
    "recipes": [
      {
        "key": "v60",
        "label": "V60",
        "ratio": "15 g kahve / 235 g su (1:15,7)",
        "grind": "Orta-ince. MHW-3 Bomber: 24–25 klik / Comandante C40: 22–23 klik",
        "temperature": "91°C",
        "duration": "2:35–2:55",
        "steps_html": "<li><strong>0:00–0:45 / 45 g</strong> bloom; sadece nazik swirl.</li><li><strong>0:45–1:05 / 95 g</strong> birinci döküş (4:6 yönteminin tatlılık aşaması).</li><li><strong>1:15–1:30 / 140 g</strong> ikinci döküş.</li><li><strong>1:40–2:00 / 235 g</strong> tamamla.</li><li><strong>2:35–2:55</strong> süzülme bitsin.</li>",
        "note": "Hafif gövdeli, narin bir kahve için biraz sıkı oran ve düşük sıcaklık: limon ve çilek net, bitiş çiçeksi.",
        "adjust": [
          [
            "Çok ince / sulu",
            "Oranı 15 g / 225 g’a sıkılaştır."
          ],
          [
            "Fermente / sirkemsi",
            "Sıcaklığı 89°C’ye düşür."
          ],
          [
            "Tatlılık az",
            "İlk %40’ı daha tatlı böl: bloom 35 g, ikinci döküş 95 g’a kadar."
          ]
        ]
      },
      {
        "key": "origami",
        "label": "Origami",
        "ratio": "15 g kahve / 230 g su (1:15,3)",
        "grind": "Orta-ince. MHW-3 Bomber: 25–26 klik / Comandante C40: 22–24 klik",
        "temperature": "91°C",
        "duration": "2:30–2:50",
        "steps_html": "<li>Origami’yi <strong>dalgalı (wave) filtre</strong> ile kullan.</li><li><strong>0:00–0:40 / 40 g</strong> bloom.</li><li><strong>0:40–1:00 / 120 g</strong> döküş.</li><li><strong>1:10–1:30 / 230 g</strong> tamamla; yatağı karıştırma.</li><li><strong>2:30–2:50</strong> süzülme bitsin.</li>",
        "note": "Düz yatak marshmallow tatlılığını ve gövdeyi biraz artırır; hafif gövdeli kahveyi daha dolgun gösterir.",
        "adjust": [
          [
            "Düz / kapalı",
            "Bir kademe incelt."
          ],
          [
            "Fermente",
            "89°C’ye in."
          ],
          [
            "Çok hafif",
            "Kahveyi 16 g’a çıkar."
          ]
        ]
      },
      {
        "key": "chemex",
        "label": "Chemex",
        "ratio": "25 g kahve / 400 g su (1:16)",
        "grind": "Orta. MHW-3 Bomber: 28–29 klik / Comandante C40: 25–27 klik",
        "temperature": "92°C",
        "duration": "3:50–4:20",
        "steps_html": "<li>Kalın filtreyi bol sıcak suyla yıka.</li><li><strong>0:00–0:45 / 60 g</strong> bloom.</li><li><strong>0:45–1:30 / 200 g</strong> geniş dairelerle dök.</li><li><strong>1:45–2:30 / 400 g</strong> tamamla.</li><li><strong>3:50–4:20</strong> süzülme bitsin.</li>",
        "note": "Chemex çiçeksi ve sarı meyve tarafını çok berrak gösterir; paylaşmak için iki fincanlık reçete.",
        "adjust": [
          [
            "Boş / zayıf",
            "Oranı 26 g / 400 g’a sıkılaştır."
          ],
          [
            "Acı",
            "İki kademe kalınlaştır."
          ]
        ]
      },
      {
        "key": "japanese",
        "label": "Japanese Iced",
        "ratio": "20 g kahve / 150 g sıcak su + 100 g buz",
        "grind": "Orta-ince. MHW-3 Bomber: 23–24 klik / Comandante C40: 20–22 klik",
        "temperature": "91°C",
        "duration": "2:15–2:35",
        "steps_html": "<li>Server’a <strong>100 g</strong> iri buz koy.</li><li><strong>0:00–0:40 / 45 g</strong> bloom.</li><li><strong>0:40–1:05 / 100 g</strong> döküş.</li><li><strong>1:10–1:25 / 150 g</strong> tamamla.</li><li><strong>2:15–2:35</strong> bittiğinde server’ı çevirerek buzu erit.</li>",
        "note": "Çilek, frambuaz ve limon soğukta daha sulu ve tatlı; yaz günleri için en keyifli versiyon.",
        "adjust": [
          [
            "Sulu",
            "Buzu 80 g’a düşür."
          ],
          [
            "Kapalı aroma",
            "Bir kademe incelt."
          ]
        ]
      }
    ]
  },
  "indonesia-frinsa-honey-tempe-1": {
    "profile": "Deneysel işlem • Yoğun meyve • Kakao nibs bitişi",
    "equipment": "Origami, AeroPress, V60, Cold Brew",
    "methods": [
      "origami",
      "aeropress",
      "v60",
      "coldbrew"
    ],
    "recipes": [
      {
        "key": "origami",
        "label": "Origami",
        "ratio": "15 g kahve / 240 g su (1:16)",
        "grind": "Orta. MHW-3 Bomber: 27–28 klik / Comandante C40: 24–26 klik",
        "temperature": "89°C",
        "duration": "2:20–2:40",
        "steps_html": "<li>Origami’yi <strong>dalgalı (wave) filtre</strong> ile kullan.</li><li><strong>0:00–0:40 / 40 g</strong> bloom; karıştırma yok.</li><li><strong>0:40–1:00 / 140 g</strong> döküş.</li><li><strong>1:10–1:25 / 240 g</strong> tamamla.</li><li><strong>2:20–2:40</strong> süzülme bitsin.</li>",
        "note": "Düşük sıcaklık, kalın öğütüm ve sakin akış: balonlu sakız ve kırmızı jöle tatlı, fermentasyon kontrollü kalır.",
        "adjust": [
          [
            "Fazla fermente",
            "87°C’ye in veya bir kademe kalınlaştır."
          ],
          [
            "Düz / tatsız",
            "91°C’ye çık."
          ],
          [
            "Kuru kakao bitişi",
            "Bir kademe kalınlaştır."
          ]
        ]
      },
      {
        "key": "aeropress",
        "label": "AeroPress",
        "ratio": "15 g kahve / 220 g su (1:14,7)",
        "grind": "Orta. MHW-3 Bomber: 24–25 klik / Comandante C40: 21–23 klik",
        "temperature": "88°C",
        "duration": "1:45–2:00",
        "steps_html": "<li>Standart konum; kağıt filtreyi ıslat.</li><li><strong>0:00–0:10 / 220 g</strong> suyu dök.</li><li><strong>0:10–0:20</strong> 2 kez nazikçe karıştır, pistonu tak.</li><li><strong>0:20–1:20</strong> bekle.</li><li><strong>1:20–2:00</strong> yavaş bastır.</li>",
        "note": "Tam demleme; koyu orman meyvesi ve kakao nibs daha dolgun, sulu gövde ön planda.",
        "adjust": [
          [
            "Ağır / fermente",
            "86°C’ye in, bekleme süresini 45 saniyeye kısalt."
          ],
          [
            "Zayıf",
            "Kahveyi 16 g’a çıkar."
          ]
        ]
      },
      {
        "key": "v60",
        "label": "V60",
        "ratio": "15 g kahve / 245 g su (1:16,3)",
        "grind": "Orta. MHW-3 Bomber: 26–27 klik / Comandante C40: 24–25 klik",
        "temperature": "89°C",
        "duration": "2:30–2:50",
        "steps_html": "<li><strong>0:00–0:40 / 40 g</strong> bloom.</li><li><strong>0:40–1:05 / 150 g</strong> tek uzun döküş.</li><li><strong>1:15–1:35 / 245 g</strong> tamamla.</li><li><strong>2:30–2:50</strong> süzülme bitsin.</li>",
        "note": "Daha berrak bir versiyon: jöle ve meyve tatlılığı öne gelir, fermentasyon daha geride kalır.",
        "adjust": [
          [
            "Fermente",
            "Bir kademe kalınlaştır."
          ],
          [
            "İnce / zayıf",
            "91°C’ye çık."
          ]
        ]
      },
      {
        "key": "coldbrew",
        "label": "Cold Brew",
        "ratio": "50 g kahve / 650 g su (1:13)",
        "grind": "Kalın. MHW-3 Bomber: 37–39 klik / Comandante C40: 35–38 klik",
        "temperature": "Soğuk su / buzdolabı",
        "duration": "12–14 saat",
        "steps_html": "<li><strong>0:00</strong> kahve ve suyu bir kavanozda karıştır.</li><li><strong>0:00–1:00</strong> kuru kalan kahve olmadığından emin ol.</li><li><strong>12–14 saat</strong> buzdolabında beklet.</li><li>Önce kaba süzgeçten, sonra kağıt filtreden süz; 5 güne kadar buzdolabında sakla.</li>",
        "note": "Soğuk demleme asiditeyi yumuşatır; balonlu sakız ve kırmızı jöle tatlılığı şekerleme gibi öne çıkar.",
        "adjust": [
          [
            "Çok yoğun",
            "1:1 soğuk su veya buzla aç."
          ],
          [
            "Fermente / keskin",
            "Süreyi 10–12 saate kısalt."
          ]
        ]
      }
    ]
  }
};

window.WemondRecipeUtils = {
  normalizeKey(key) {
    const map = {
      'filter-machine':'filtre-makinesi',
      'cold-brew':'coldbrew',
      'french-press':'frenchpress',
      'moka-pot':'mokapot'
    };
    return map[key] || key;
  },
  grinderLabel(key) {
    const k = this.normalizeKey(key);
    if (k === 'espresso') return 'İnce';
    if (k === 'v60' || k === 'origami' || k === 'aeropress' || k === 'japanese' || k === 'mokapot') return 'Orta-ince';
    if (k === 'chemex' || k === 'filtre-makinesi') return 'Orta';
    if (k === 'frenchpress' || k === 'coldbrew') return 'Kalın';
    return 'Orta';
  },
  grinderRefs(grind, methodKey) {
    const text = String(grind || '').replace(/\s+/g, ' ').trim();
    const mhw = text.match(/MHW-?3(?:\s+Bomber)?\s*:\s*([^/;|.]+?(?:klik|ayarı))/i);
    const c40 = text.match(/(?:Comandante\s*)?C40\s*:\s*([^/;|.]+?klik)/i);
    const refs = [];
    if (mhw) refs.push('MHW-3 ' + mhw[1].trim());
    if (c40) refs.push('C40 ' + c40[1].trim());
    if (refs.length) return refs.join(' · ');

    const fallback = {
      espresso: 'MHW-3 espresso ayarı · C40 8–10 klik',
      v60: 'MHW-3 24–26 klik · C40 21–24 klik',
      origami: 'MHW-3 25–27 klik · C40 22–25 klik',
      chemex: 'MHW-3 29–31 klik · C40 27–30 klik',
      aeropress: 'MHW-3 23–25 klik · C40 20–22 klik',
      japanese: 'MHW-3 24–26 klik · C40 21–23 klik',
      'filtre-makinesi': 'MHW-3 27–30 klik · C40 25–28 klik',
      coldbrew: 'MHW-3 36–39 klik · C40 35–39 klik',
      frenchpress: 'MHW-3 34–36 klik · C40 32–35 klik',
      mokapot: 'MHW-3 18–21 klik · C40 16–19 klik'
    };
    return fallback[this.normalizeKey(methodKey)] || '';
  },
  find(productHandle, methodKey) {
    const aliases = {
      'honduras-shg':'honduras-shg',
      'honduras-shb':'honduras-shg',
      'peru-shb-grade-1':'peru-shb-grade-1-250g',
      'peru-250g':'peru-shb-grade-1-250g',
      'peru':'peru-shb-grade-1-250g'
    };
    const handle = aliases[productHandle] || productHandle;
    const product = window.WemondProductRecipes?.[handle];
    if (!product) return null;
    const wanted = this.normalizeKey(methodKey);
    return product.recipes?.find(recipe => this.normalizeKey(recipe.key) === wanted) || null;
  }
};

/* Product views are parsed before this deferred recipe asset executes. Notify
   those views once the shared product-specific recipe source is available so
   the initially rendered fallback can be reconciled without blocking paint. */
document.dispatchEvent(new CustomEvent('wemond:product-recipes-ready'));
